// extracted by mini-css-extract-plugin
module.exports = {"header":"InstitutionHeader_header__fX9aV","breadcrumb":"InstitutionHeader_breadcrumb__2yH0U","back":"InstitutionHeader_back__31gf4"};